import Card from '@/components/UI/Card';
import EntityLink from '@/components/Entity/EntityLink';
import { useAssetSessionPrices } from '@/hooks/useAssetSessionPrices';
import AssetSessionPriceDisplay from './AssetSessionPriceDisplay';

const MARKET_SYMBOLS = ['SPY', 'QQQ'];

export default function MarketOverviewCard() {
    const query = useAssetSessionPrices(MARKET_SYMBOLS);

    return (
        <Card title="Markets" subtitle="Regular and extended hours · Minute prices">
            <div className="grid gap-6 sm:grid-cols-2">
                {MARKET_SYMBOLS.map((symbol) => {
                    const prices = query.data?.find((item) => item.symbol === symbol);
                    return (
                        <div key={symbol}>
                            <div className="mb-3 text-base font-semibold">
                                {prices ? (
                                    <EntityLink
                                        className="text-blue-400 hover:text-blue-300"
                                        entity={{ entityId: prices.assetId, entityType: 'Asset' }}
                                    >
                                        {symbol}
                                    </EntityLink>
                                ) : (
                                    symbol
                                )}
                                <span className="ml-2 text-sm font-normal text-zinc-500">
                                    {symbol === 'SPY' ? 'S&P 500 ETF' : 'Nasdaq-100 ETF'}
                                </span>
                            </div>
                            <AssetSessionPriceDisplay prices={prices} isLoading={query.isLoading} isError={query.isError} />
                        </div>
                    );
                })}
            </div>
        </Card>
    );
}
